import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import api from "@/lib/api";

export default function Announcements() {
    const [settings, setSettings] = useState(null);
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        api.get("/settings").then((r) => setSettings(r.data));
        api.get("/posts").then((r) => setPosts(r.data));
    }, []);

    return (
        <PublicLayout settings={settings}>
            <section className="max-w-6xl mx-auto px-6 py-16">
                <div className="font-mono text-xs uppercase tracking-[0.25em] text-[hsl(var(--muted-foreground))]">News</div>
                <h1 className="font-display text-4xl sm:text-5xl mt-3">Announcements & posts.</h1>
                <p className="mt-4 max-w-xl text-[hsl(var(--muted-foreground))]">Share any post with anyone — each has a public link.</p>

                <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {posts.map((p) => (
                        <Link
                            key={p.id}
                            to={`/post/${p.id}`}
                            className="card-clay overflow-hidden hover:-translate-y-1 transition-transform"
                            data-testid={`announcement-card-${p.id}`}
                        >
                            {p.image_url && <img src={p.image_url} alt={p.title} className="w-full h-48 object-cover" />}
                            <div className="p-5">
                                <div className="flex gap-2 items-center">
                                    {p.is_announcement && (
                                        <span className="text-[10px] font-mono uppercase tracking-widest bg-[hsl(var(--accent))] text-white px-2 py-0.5 rounded">
                                            Announcement
                                        </span>
                                    )}
                                    <span className="font-mono text-[10px] uppercase tracking-widest text-[hsl(var(--muted-foreground))]">
                                        {new Date(p.created_at).toLocaleDateString()}
                                    </span>
                                </div>
                                <div className="font-display text-lg mt-3">{p.title}</div>
                                <p className="text-sm mt-2 text-[hsl(var(--muted-foreground))] line-clamp-3">{p.body}</p>
                            </div>
                        </Link>
                    ))}
                    {posts.length === 0 && (
                        <div className="text-[hsl(var(--muted-foreground))]">No posts yet.</div>
                    )}
                </div>
            </section>
        </PublicLayout>
    );
}
